import React from "react";
import "./style.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const BarGraph = ({ dashboardDataByprojId }) => {
  const bugReportAgainstWCAG =
    dashboardDataByprojId?.bugReportedAgainstWCAGGuideline;

  return (
    <div className="dashboard-graph">
      <div className="line-graph" style={{ width: "100%", height: 650 }}>
        <div className="graph-header">
          <h6>Bug reported against WCAG</h6>
        </div>

        <div className="bar-graph">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={400}
              height={250}
              data={bugReportAgainstWCAG}
              margin={{
                top: 15,

                right: 30,

                left: 20,

                bottom: 220,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />

              <XAxis
                dataKey="guideline"
                angle={-45}
                textAnchor="end"
                interval={0}
              />

              <YAxis />

              <Tooltip />

              <Bar dataKey="issuesReported" fill="#BFA7ED" maxBarSize={50} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default BarGraph;
